import React from "react";
import { Container as MuiContainer, Box } from "@mui/material";

export const Container = ({ children, maxWidth = "lg", sx = {}, ...props }) => {
  return (
    <MuiContainer
      maxWidth={maxWidth}
      sx={{
        padding: { xs: 2, md: 3 },
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiContainer>
  );
};

export const ContentWrapper = ({
  children,
  maxWidth = "md",
  sx = {},
  ...props
}) => (
  <Box
    sx={{
      maxWidth,
      mx: "auto",
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);
